import stripe from 'libraries/stripe'
import { isNil, get } from 'lodash'
import { getLastFourDigitsOfMethodCard } from 'data/stripe/StripePaymentMethod'
import Time from 'models/data/utils/Time';
import StripeSubscription from './StripeSubscription';

class StripeCustomer {
	
    static id = stripeCustomer => get(stripeCustomer, "id", "");

	static email = stripeCustomer => get(stripeCustomer, "email", "");

	static async createOrUpdate(customerEmail: string, stripePaymentMethodId: string) {
		const existingCustomer = await StripeCustomer.lookupByEmail(customerEmail);
		if (!isNil(existingCustomer)) {
            const existingCustomerId = StripeCustomer.id(existingCustomer)
            const updatedCustomer = await StripeCustomer.updatePaymentMethod(existingCustomerId, stripePaymentMethodId)
            return updatedCustomer
        }

		const newCustomer = await StripeCustomer.create(customerEmail, stripePaymentMethodId);
		if (isNil(newCustomer)) throw new Error("Catch this with a StripeError object");

		return newCustomer;
	}

	static async lookupByEmail(email: string) {
		let customerList = await stripe.customers.list({ email });
		const [existingCustomer] = get(customerList, "data", []);
		return existingCustomer;
	}

	static async lookupById(id: string) {
        let customer = null
        try {
            customer = await stripe.customers.retrieve(id);
        } catch(error) {}
		return customer;
	}

	static async create(email: string, paymentMethodId: string) {
		const newCustomer = await stripe.customers.create({ email, payment_method: paymentMethodId });
		return newCustomer;
	}

    static mostRecentlyCreatedSubscription(stripeCustomer: any) {
        let subscriptions = StripeCustomer.subscriptions(stripeCustomer);
		subscriptions.sort((a, b) => b.created - a.created);
		const [mostRecentSubscription] = subscriptions;
		return mostRecentSubscription ? mostRecentSubscription : {};
    }

    static subscriptionId(stripeCustomer: any) {
        const firstSubscription = StripeCustomer.mostRecentlyCreatedSubscription(stripeCustomer);
        return StripeSubscription.id(firstSubscription)
    }

    static subscriptionHasBeenCancelled(stripeCustomer: any) {
        const firstSubscription = StripeCustomer.mostRecentlyCreatedSubscription(stripeCustomer);
        return StripeSubscription.cancelAtPeriodEnd(firstSubscription)
    }

	static endOfCurrentBillingPeriod(stripeCustomer: any) {
        const firstSubscription = StripeCustomer.mostRecentlyCreatedSubscription(stripeCustomer);
        const firstSubscriptionEndsAt = StripeSubscription.endsAt(firstSubscription);
		return Time.unixTimestampToIsoString(firstSubscriptionEndsAt);
	}

	static subscriptions(stripeCustomer: any) {
		return get(stripeCustomer, "subscriptions.data", []);
	}

	static numSubscriptions(stripeCustomer: any) {
		return StripeCustomer.subscriptions(stripeCustomer).length;
	}

	static async lastFourDigitsOfCard(stripeCustomer: any) {
		const paymentMethodId = stripeCustomer?.invoice_settings?.default_payment_method
		if(!paymentMethodId){
			return '0000'; 
		}
		const paymentMethod = await stripe.paymentMethods.retrieve(
			paymentMethodId
		  );
		const lastFourDigitsOfCard = getLastFourDigitsOfMethodCard(paymentMethod);
		return lastFourDigitsOfCard;
    }

    static async updatePaymentMethod(stripeCustomerId: string, paymentMethodId: string) {

		await stripe.paymentMethods.attach(
			paymentMethodId,
			{customer: stripeCustomerId}
		  );


        const updatedCustomer = await stripe.customers.update(
          stripeCustomerId,
          {
			  invoice_settings: {
				  default_payment_method: paymentMethodId
			  }
          }
        );
        return updatedCustomer;
    }
}

export default StripeCustomer
